var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1501_17013)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.4373 33.75C33.8017 33.75 31.2741 34.8167 29.4105 36.7155C27.5468 38.6144 26.4998 41.1897 26.4998 43.875M36.4373 24.75C33.8017 24.75 31.2741 25.8167 29.4105 27.7155C27.5468 29.6144 26.4998 32.1897 26.4998 34.875M36.4373 15.75C33.8017 15.75 31.2741 16.8167 29.4105 18.7155C27.5468 20.6144 26.4998 23.1897 26.4998 25.875M17.6665 33.75C22.5469 33.75 26.4998 38.2838 26.4998 43.875M17.6665 24.75C22.5469 24.75 26.4998 29.2838 26.4998 34.875M17.6665 15.75C22.5469 15.75 26.4998 20.2838 26.4998 25.875M26.4998 9V22.5",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1501_17013"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 54,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrop);
export default __webpack_public_path__ + "static/media/crop.0b68c11efe075f1f96293abb14cf11d6.svg";
export { ForwardRef as ReactComponent };